var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-error"},[_c('h1',{staticClass:"page-error__title",domProps:{"textContent":_vm._s(_vm.title)}}),_c('h2',{staticClass:"page-error__subtitle",domProps:{"textContent":_vm._s(_vm.subtitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }